import * as types from '../utils/mutation-types.js'
// import api from '../../api/api.js'

const state = {
  shain_no: null,
  shain_name: null,
  org_id: null,
  post_id: null,
  job_id: null,
  start_hire_date: null,
  end_hire_date: null,
  start_retire_date: null,
  end_retire_date: null,
  serve_length_year: null,
  serve_length_month: null,
  serve_length_date: null,
  recruit_id: null
}

const mutations = {
  [types.SEARCH_SHAIN_NO] (state, num) {
    state.shain_no = num
  }
}

const getters = {
  getShainNo: state => state.shainNo
}

const actions = {
  [types.SEARCH_SHAIN_NO] ({ commit }, num) {
    commit(types.SEARCH_SHAIN_NO, num)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js